/**
 * 通知バッジ「最後に見た時刻」の件数計算。
 *
 * バッジに表示される件数 = viewedAt より後に作成された未読通知の数。
 * ベルアイコンタップでviewedAtを現在時刻に更新し、バッジだけクリアする
 * （通知自体の既読化は行わない仕様）。
 *
 * PRODUCT_DEV-699: viewedAt の保存先は localStorage から個人設定（サーバ）へ移した。
 * 読み書きは `usePreference("notificationViewedAt", ...)`、ここに残るのは
 * **保存先を知らない純粋な計算**だけ。localStorage が消えると過去の通知が全部
 * 未読として再カウントされ、赤バッジが出っぱなしになるのが移行前の症状だった。
 */

/**
 * バッジに表示する件数を計算する。
 * 「viewedAt以降に作成された未読通知」のみカウント。
 */
export function calcBadgeCount(
  notifications: { isRead: boolean; createdAt: string }[],
  viewedAt: string | null,
): number {
  return notifications.filter((n) => {
    if (n.isRead) return false;
    if (viewedAt && n.createdAt <= viewedAt) return false;
    return true;
  }).length;
}
